export default "/images/vendor/flag-icons/flags/1x1/sk.svg?8ebdd96622429b4fe475fa3e6583bd88";